__webpack_require__.p = "/deadman-points-calc/";